<template>
  <div>
    <BlNavBarMv
      is-dark-mode
      has-back-button
      @handleBackButtonClick="$emit('back')"
    />
    <div class="item-list">
      <BlTextAv
        color="inverse"
        variation="body-16"
        weight="bold"
        class="u-align-center mb-20"
      >
        Pilih alat yang mau dipesan:
      </BlTextAv>
      <div class="item-list__content p-16">
        <div v-if="isLoading" data-testid="shimmer">
          <BlFlexContainerMv align-items="center">
            <BlFlexItemAv v-for="n in 3" :key="n" :grow="1">
              <BlShimmerAv
                width="100px"
                height="150px"
                class="item-card-shimmer"
              />
            </BlFlexItemAv>
          </BlFlexContainerMv>
        </div>
        <Hooper
          v-else-if="isLoaded"
          ref="hooper"
          :items-to-show="3"
          :touch-drag="isEnableToSlide"
          :mouse-drag="isEnableToSlide"
          style="height: 176px"
          data-testid="item-slides"
        >
          <Slide
            v-for="(item, index) in itemList"
            :key="item.id"
            :index="index"
          >
            <ItemCard
              :item="item"
              data-testid="item-card"
              @click.native="handleClickedItem(item)"
            />
          </Slide>
          <HooperNavigation v-if="isEnableToSlide" slot="hooper-addons" />
        </Hooper>
        <div v-else-if="isError" class="u-align-center mt-32">
          <BlTextAv class="mb-8" color="inverse">
            Terjadi kesalahan. Silakan coba lagi.
          </BlTextAv>
          <BlButtonAv
            variation="outline"
            size="extra-small"
            data-testid="retry-button"
            @click="initialize"
          >
            Muat ulang
          </BlButtonAv>
        </div>
      </div>
    </div>

    <div class="item-benefit p-16 pb-0">
      <BlTextAv variation="body-16" weight="bold" class="mb-16">
        Keuntungan Alat ATM Mitra
      </BlTextAv>

      <BlCardMv
        v-for="(benefit, index) in benefitList"
        :key="index"
        is-outlined
        :shadow="false"
        class="p-12 mb-12"
      >
        <BlFlexContainerMv align-items="center">
          <BlFlexItemAv basis="48" class="mr-12">
            <img
              :src="benefit.img"
              aria-hidden="true"
              width="48"
              height="48"
              loading="lazy"
            />
          </BlFlexItemAv>
          <BlFlexItemAv :shrink="1">
            <BlTextAv>{{ benefit.content }}</BlTextAv>
          </BlFlexItemAv>
        </BlFlexContainerMv>
      </BlCardMv>
    </div>

    <div class="item-ordering-guide p-16">
      <BlTextAv variation="body-16" weight="bold" class="mb-16">
        Cara Pesan
      </BlTextAv>

      <BlFlexContainerMv
        v-for="(guide, index) in orderingGuide"
        :key="index"
        align-items="flex-start"
        class="mb-16"
      >
        <BlFlexItemAv basis="24" class="mr-12">
          <div class="list-index">
            <BlTextAv weight="bold" color="inverse">
              {{ index + 1 }}
            </BlTextAv>
          </div>
        </BlFlexItemAv>
        <BlFlexItemAv :shrink="1">
          <BlTextAv>{{ guide }}</BlTextAv>
        </BlFlexItemAv>
      </BlFlexContainerMv>
    </div>
  </div>
</template>

<script>
/* eslint global-require: 0 */
import { mapState, mapGetters, mapActions } from 'vuex';
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import {
  BlButtonAv,
  BlCardMv,
  BlFlexContainerMv,
  BlFlexItemAv,
  BlNavBarMv,
  BlShimmerAv,
  BlTextAv,
} from '@bukalapak/bazaar-mweb';
import ItemCard from '../components/ItemCard.vue';

const TOTAL_ITEM_PER_SLIDE = 3;
const BENEFIT_LIST = [
  {
    img: require('../images/img_small_mitra_qr_code.png'),
    content: 'Bantu proses transaksi dengan pelanggan jadi lebih cepat.',
  },
  {
    img: require('../images/img_small_mitra_logo.png'),
    content:
      'Tempat usaha makin terpercaya,  verifikasi transaksi lebih mudah.',
  },
  {
    img: require('../images/img_small_money.png'),
    content:
      'Pilihan sistem pembayaran alat disesuaikan dengan transaksi harian.',
  },
];
const ORDERING_GUIDE = [
  'Pilih alat yang kamu inginkan.',
  'Pilih sistem pembayaran dan masukkan detail alamat untuk pengiriman alat.',
  'Tunggu alat sampai, bisa langsung dipakai.',
];

const TRACKER_SCREEN_NAME = 'pesan-alat-atm-mitra';

export default {
  name: 'LandingPage',
  components: {
    BlNavBarMv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlCardMv,
    BlShimmerAv,
    BlButtonAv,
    BlTextAv,
    Hooper,
    Slide,
    HooperNavigation,
    ItemCard,
  },
  data() {
    return {
      totalItemPerSlide: TOTAL_ITEM_PER_SLIDE,
      benefitList: BENEFIT_LIST,
      orderingGuide: ORDERING_GUIDE,
    };
  },
  computed: {
    ...mapState('mitraItems', {
      itemList: 'mitraItems',
    }),
    ...mapGetters('mitraItems', ['isLoading', 'isLoaded', 'isError']),
    isEnableToSlide() {
      return this.itemList.length > TOTAL_ITEM_PER_SLIDE;
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions('mitraItems', ['retrieveMitraItems']),
    async initialize() {
      await this.retrieveMitraItems();
      this.visitScreenTrack();
    },
    handleClickedItem(item) {
      // Track item click
      this.$tracker.itemMitraItemClickTrack({
        click_source: `click-product-${item.id}`,
        current_screen: TRACKER_SCREEN_NAME,
        target_screen: `detail-product-${item.id}`,
        params: JSON.stringify({
          item_id: item.id,
          item_name: item.name,
          item_status: item.status,
        }),
      });
      if (item.status === 'upcoming' || item.status === 'onhold') return;
      if (item.status === 'active' || item.status === 'failed') {
        this.$router.push({ name: 'ItemDetailPage', params: { id: item.id } });
      } else {
        this.$router.push({
          name: 'TransactionDetailPage',
          params: { id: item.transaction.id },
        });
      }
    },
    visitScreenTrack() {
      if (this.$tracker) {
        this.$tracker.itemMitraLandingPageVisitTrack({
          current_screen: TRACKER_SCREEN_NAME,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-list {
  background: linear-gradient(180deg, #142568 0%, #562361 63.91%, #e31e52 100%);
  box-shadow: 0px 1px 5px 0px #1f1f1f26;
  height: 313px;
  margin-top: -56px;
  padding-top: 56px;

  &__content {
    max-height: 170px;
  }
}

.item-card-shimmer {
  display: block;
  border-radius: 4px;
  margin: 0 auto;
}

.list-index {
  background: #3a5fd6;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hooper-navigation {
  overflow: hidden;

  ::v-deep {
    .icon {
      width: 36px;
      height: 36px;

      path:last-child {
        fill: #333 !important;
      }
    }

    .hooper-prev {
      padding: 0;
      left: -16px;
    }

    .hooper-next {
      padding: 0;
      right: -16px;
    }
  }
}
</style>
